import {Box, styled, Tooltip} from "@mui/material";
import React from "react";
import {getIcon} from "../../helpers/getIcon";
import {getIconTitle} from "../../helpers/getIconTitle";

interface ArticleInterface {
    title: string;
    text: string;
    source: string;
    type: string;
}

const ArticleContainer = styled(Box)({
    "& p":{
        color: "#D3D3D3",
        "&:first-of-type":{
            fontSize: "18px",
            fontWeight: 600,
            color: "#D3D3D3"
        },
        "&:nth-of-type(2)":{
            fontSize: "14px",
            fontWeight: 400,
        },
        "&:nth-of-type(3)":{
            color: "#A9A9A9",
            fontSize: "14px",
            fontWeight: 600,
            textDecoration: "underline"
        }
    }
});

const ArticleMenuFooter = styled(Box)({
    display: "flex",
    justifyContent: "space-between"
});

export const ArticleMenuFooterText = styled(Box)({
    display: "flex",
    gap: "10px",
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 600,
    "& span":{
        textDecoration: "underline"
    },
});

const Article = ({title, text, source, type}: ArticleInterface):JSX.Element => {
    return (
        <ArticleContainer>
            <p>
                {title}
            </p>
            <p>
                {text}
            </p>
            <p>
                Source: {source}
            </p>
    
            <ArticleMenuFooter>
                <Tooltip title={getIconTitle(type)}>
                    <ArticleMenuFooterText sx={{
                        display: "flex", alignItems: "center"
                    }}>Type: <span>{type}</span>
                        {getIcon(type)}
                    </ArticleMenuFooterText>
                </Tooltip>
            </ArticleMenuFooter>
        </ArticleContainer>
    );
};

export default Article;
